/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const membershipAllocationErrorResponseSchema = z.object({
  attemptedTotal: z.number(),
  bindingSegment: z.string(),
  code: z.string(),
  currentTotal: z.number(),
  memberId: z.int(),
  message: z.string(),
  oldTotal: z.number(),
});
